var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loading-indicator",style:(_vm.props.styleOverride),attrs:{"data-testid":"loading-indicator"}})}
var staticRenderFns = []

export { render, staticRenderFns }